import { useEffect } from 'react';
import { useMap } from '@vis.gl/react-google-maps';

export const MapReuseReset = () => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    map.setMapTypeId('roadmap');
    map.getStreetView().setVisible(false);
  }, [map]);

  return null;
};
